import { Component, OnInit } from '@angular/core';
import { SharedService } from 'app/modules/common/services/shared-service';
import { CoordinatorContact } from 'app/modules/coordinator/entities/coordinator-contact';
import { CoordinatorStatisticsService } from 'app/modules/coordinator/services/coordinator-statistics.service';
import { EmpresaTreeViewService } from 'app/modules/employee/services/empresa-treeView.service';

@Component({
    selector: 'app-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss'],
    standalone: false
})
export class ContactsComponent implements OnInit {

  public selectedCompanyId = 0;
  public isLoading = true;
  public contactData: Array<CoordinatorContact>;

  constructor(
    private empresaTreeViewService: EmpresaTreeViewService,
    private coordinatorStatisticsService: CoordinatorStatisticsService,
    private sharedService: SharedService) { 
      this.registerTreeViewListener();
    }

  ngOnInit(): void {
    this.selectedCompanyId = JSON.parse(localStorage.getItem('Empresa'));
    if (this.selectedCompanyId > 0) {
      this.getContactData();
    }
  }

  private registerTreeViewListener(): void {
    this.empresaTreeViewService.EmpId.subscribe(res => {
      this.selectedCompanyId = res;
      if (this.selectedCompanyId > 0 && !this.coordinatorStatisticsService.isStatisticsHidden) {
        this.getContactData();
      }
    });
  }

  private getContactData(): void {
    this.isLoading = true;
    this.coordinatorStatisticsService.GetContactData(String(this.selectedCompanyId)).subscribe(res => {
      if (res.code === 0) {
        this.contactData = res.result;
      } else {
        this.sharedService.ShowSnackBar('No se pudieron cargar los datos de contacto de la empresa.');
      }
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      console.error(error);
      this.sharedService.ShowSnackBar('Se produjo un error, actualice la página.');
    });
  }

}
